import React, { useState } from 'react';
import { CloseIcon, HeartIcon } from './Icons';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';

export default function MenuDrawer({ 
  isOpen, 
  onClose, 
  setView, 
  setIsBookingOpen, 
  setSelectedCollectionId,
  currentUser,
  setCurrentUser,
  setIsAuthOpen,
  wishlist = [],
  setJournalSection
}) {
  const [activeSection, setActiveSection] = useState(null);

  const isFirebaseConfigured = () => {
    try {
      const config = auth?.app?.options;
      return config && config.apiKey && config.apiKey !== "YOUR_API_KEY";
    } catch (e) {
      return false;
    }
  };

  const handleSignOut = async () => {
    if (isFirebaseConfigured()) {
      try {
        await signOut(auth);
      } catch (error) {
        console.error("Sign Out Error:", error);
      }
    }
    if (setCurrentUser) {
      setCurrentUser(null);
      localStorage.removeItem('hok_currentUser');
    }
    onClose();
  };

  const toggleSection = (section) => {
    setActiveSection(prev => prev === section ? null : section);
  };

  const handleNav = (targetView, anchor) => {
    onClose();
    setView(targetView);
    if (anchor) {
      setTimeout(() => {
        const el = document.getElementById(anchor);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 150);
    }
  };

  const menuData = [
    {
      id: 'collections',
      title: 'Collections',
      items: [
        { label: 'Polki Heirlooms', action: () => { setSelectedCollectionId?.(1); onClose(); setView('collections'); } },
        { label: 'Classic CZ', action: () => { setSelectedCollectionId?.(2); onClose(); setView('collections'); } },
        { label: 'Eternal Moissanite', action: () => { setSelectedCollectionId?.(3); onClose(); setView('collections'); } },
        { label: 'Royal Meenakari', action: () => { setSelectedCollectionId?.(4); onClose(); setView('collections'); } },
        { label: 'Jaipur Blue Pottery', action: () => { setSelectedCollectionId?.(5); onClose(); setView('collections'); } },
        { label: 'Minimalist Silver', action: () => { setSelectedCollectionId?.(6); onClose(); setView('collections'); } }
      ]
    },
    {
      id: 'jewellery',
      title: 'Jewellery',
      items: [
        { label: 'Rings', action: () => { onClose(); if (window.setHokCategory) window.setHokCategory('Rings'); setView('marketplace'); } },
        { label: 'Earrings', action: () => { onClose(); if (window.setHokCategory) window.setHokCategory('Earrings'); setView('marketplace'); } },
        { label: 'Necklaces', action: () => { onClose(); if (window.setHokCategory) window.setHokCategory('Necklaces'); setView('marketplace'); } },
        { label: 'Pendants', action: () => { onClose(); if (window.setHokCategory) window.setHokCategory('Pendants'); setView('marketplace'); } },
        { label: 'Bracelets', action: () => { onClose(); if (window.setHokCategory) window.setHokCategory('Bracelets'); setView('marketplace'); } },
        { label: 'Bangles', action: () => { onClose(); if (window.setHokCategory) window.setHokCategory('Bangles'); setView('marketplace'); } },
        { label: 'Maangtika', action: () => { onClose(); if (window.setHokCategory) window.setHokCategory('Maangtika'); setView('marketplace'); } },
        { label: 'Nath', action: () => { onClose(); if (window.setHokCategory) window.setHokCategory('Nath'); setView('marketplace'); } },
        { label: 'Brooch', action: () => { onClose(); if (window.setHokCategory) window.setHokCategory('Brooch'); setView('marketplace'); } },
        { label: 'Baajubandh', action: () => { onClose(); if (window.setHokCategory) window.setHokCategory('Baajubandh'); setView('marketplace'); } },
        { label: 'Sets', action: () => { onClose(); if (window.setHokCategory) window.setHokCategory('Sets'); setView('marketplace'); } }
      ]
    },
    {
      id: 'bespoke',
      title: 'Bespoke',
      items: [
        { label: 'Bridal Jewellery', action: () => { onClose(); setView('collections'); } },
        { label: 'Custom Creations', action: () => { onClose(); setView('collections'); } },
        { label: 'Appointment Request', action: () => { onClose(); setIsBookingOpen(true); } }
      ]
    },
    {
      id: 'thehouse',
      title: 'The House',
      items: [
        { label: 'The Making', action: () => handleNav('home', 'craftsmanship') },
        { label: 'Hallmark & Authenticity', action: () => handleNav('home', 'our-story') }
      ]
    },
    {
      id: 'journal',
      title: 'Journal',
      items: [
        { 
          label: 'Care Guide', 
          action: () => { 
            onClose(); 
            if (setJournalSection) setJournalSection('top');
            setView('journal'); 
            window.scrollTo({ top: 0, behavior: 'smooth' });
          } 
        },
        { 
          label: 'Client Diaries', 
          action: () => { 
            onClose(); 
            if (setJournalSection) setJournalSection('preserving-your-jewellery');
            setView('journal');
            setTimeout(() => {
              const el = document.getElementById('preserving-your-jewellery');
              if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }, 180);
          } 
        }
      ]
    }
  ];

  return (
    <div className={`fixed inset-0 z-[60] transition-opacity duration-300 pointer-events-none ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0'}`}>
      <div onClick={onClose} className="absolute inset-0 bg-black/40 backdrop-blur-xs transition-opacity" />
      <div className={`absolute inset-y-0 left-0 z-[60] bg-white shadow-2xl p-5 sm:p-8 md:p-12 transition-transform duration-300 flex flex-col justify-between w-full sm:w-[420px] md:w-[480px] ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        {/* Top Row: Header with Title & Close Button */}
        <div className="flex justify-between items-center pb-3 border-b border-[#584738]/10">
          <span className="font-serif text-[13px] uppercase tracking-[0.22em] text-[#584738]/60 font-medium">
            Menu
          </span>
          <button 
            onClick={onClose} 
            className="p-2 -mr-2 text-[#584738]/60 hover:text-[#584738] active:scale-90 transition-all focus:outline-none cursor-pointer touch-manipulation" 
            aria-label="Close Menu"
          >
            <CloseIcon />
          </button>
        </div>

        {/* Navigation Links */}
        <nav className="flex-1 flex flex-col justify-start gap-1 my-4 sm:my-6 pr-1 overflow-y-auto min-h-0 scrollbar-thin">
          {/* Home Option */}
          <button 
            onClick={() => { onClose(); setView('home'); }} 
            className="text-left font-sans text-[13.5px] md:text-[14px] tracking-[0.16em] uppercase font-semibold text-[#584738] hover:text-black active:bg-[#584738]/5 transition-colors focus:outline-none flex justify-between items-center w-full py-2.5 px-2 rounded-xs border-b border-[#584738]/5 cursor-pointer touch-manipulation"
          >
            <span>Home</span>
          </button>

          {/* Accordions */}
          {menuData.map((section) => {
            const isOpen = activeSection === section.id;
            return (
              <div key={section.id} className="flex flex-col w-full border-b border-[#584738]/5 pb-1">
                <button
                  onClick={() => toggleSection(section.id)}
                  className="text-left font-sans text-[13.5px] md:text-[14px] tracking-[0.16em] uppercase font-semibold text-[#584738] hover:text-black active:bg-[#584738]/5 transition-colors focus:outline-none flex justify-between items-center w-full py-2.5 px-2 rounded-xs cursor-pointer touch-manipulation"
                >
                  <span>{section.title}</span>
                  <svg 
                    className={`w-3.5 h-3.5 opacity-60 transition-transform duration-300 ${isOpen ? 'rotate-180' : 'rotate-0'}`} 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="1.5" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                  </svg>
                </button>
                
                {/* Smooth sliding items */}
                <div 
                  className={`grid transition-all duration-300 ease-in-out ${
                    isOpen ? 'grid-rows-[1fr] opacity-100 mt-1 mb-2' : 'grid-rows-[0fr] opacity-0 pointer-events-none'
                  }`}
                >
                  <div className="overflow-hidden flex flex-col gap-1.5 pl-3.5 pb-1 border-l-2 border-[#584738]/15 ml-2">
                    {section.items.map((item, idx) => (
                      <button
                        key={idx}
                        onClick={item.action}
                        className="text-left font-sans text-[12.5px] tracking-[0.12em] text-[#584738]/75 hover:text-black hover:font-medium active:bg-[#584738]/5 py-1.5 px-2 rounded-xs transition-all duration-150 focus:outline-none cursor-pointer touch-manipulation"
                      >
                        {item.label}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}

          {/* Wishlist Option - Just above Sign In */}
          <button 
            onClick={() => { onClose(); setView('wishlist'); }} 
            className="text-left font-sans text-[13.5px] md:text-[14px] tracking-[0.16em] uppercase font-semibold text-[#584738] hover:text-black active:bg-[#584738]/5 transition-colors focus:outline-none flex justify-between items-center w-full py-2.5 px-2 rounded-xs border-b border-[#584738]/5 cursor-pointer touch-manipulation"
          >
            <div className="flex items-center gap-2.5">
              <HeartIcon 
                filled={wishlist.length > 0} 
                className="w-4 h-4"
                activeColor="#E11D48"
              />
              <span className={wishlist.length > 0 ? 'text-[#584738] font-bold' : ''}>Wishlist</span>
            </div>
            {wishlist.length > 0 ? (
              <span className="text-[10px] font-sans font-bold bg-[#E11D48] text-white px-2 py-0.5 rounded-full tracking-wider shadow-xs">
                {wishlist.length}
              </span>
            ) : (
              <span className="text-[11px] font-sans font-normal text-[#584738]/40 lowercase tracking-normal">
                0 items
              </span>
            )}
          </button>

          {/* Sign In / Sign Out Option */}
          {currentUser ? (
            <button 
              onClick={handleSignOut} 
              className="text-left font-sans text-[13.5px] md:text-[14px] tracking-[0.16em] uppercase font-semibold text-[#584738] hover:text-black active:bg-[#584738]/5 transition-colors focus:outline-none flex justify-between items-center w-full py-2.5 px-2 rounded-xs border-b border-[#584738]/5 cursor-pointer touch-manipulation"
            >
              <span>Sign Out</span>
            </button>
          ) : (
            <button 
              onClick={() => { onClose(); setIsAuthOpen?.(true); }} 
              className="text-left font-sans text-[13.5px] md:text-[14px] tracking-[0.16em] uppercase font-semibold text-[#584738] hover:text-black active:bg-[#584738]/5 transition-colors focus:outline-none flex justify-between items-center w-full py-2.5 px-2 rounded-xs border-b border-[#584738]/5 cursor-pointer touch-manipulation"
            >
              <span>Sign In</span>
            </button>
          )}
        </nav>

        {/* Footer Contact & Socials */}
        <div className="flex flex-col gap-4 mt-auto pt-3 border-t border-[#584738]/10 pb-2 sm:pb-0">
          {/* Book Appointment CTA */}
          <button
            onClick={() => { onClose(); setIsBookingOpen(true); }}
            className="text-left font-sans text-xs tracking-[0.15em] uppercase border-b border-[#584738] pb-1 hover:text-black transition-colors self-start font-semibold text-[#584738] cursor-pointer touch-manipulation"
          >
            Book Appointment &rarr;
          </button>
          
          <div className="flex items-center justify-between gap-4">
            <span className="text-[10px] tracking-[0.15em] uppercase text-[#584738]/50 font-bold font-sans">Jaipur &bull; Since 2017</span>
            <div className="flex gap-4 items-center">
              {/* Instagram */}
              <a
                href="#"
                className="text-[#584738] hover:opacity-75 p-1 transition-opacity"
                aria-label="Instagram"
              >
                <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" />
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
              </a>
              
              {/* LinkedIn */}
              <a
                href="#"
                className="text-[#584738] hover:opacity-75 p-1 transition-opacity"
                aria-label="LinkedIn"
              >
                <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z" />
                  <rect x="2" y="9" width="4" height="12" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
